import { Button, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useRef, useState } from "react";
import { parseImportedCampaigns } from "./utils/ImportCampaignManager";
import { useBoundStore } from "useStore";

export default function DragDTFile({ loading, onImport }) {
  const [isDragActive, setIsDragActive] = useState(false);
  const inputRef = useRef(null);
  const setAlertState = useBoundStore((state) => state.setAlertState);

  const processFile = async (file) => {
    if (!file) return;
    if (!file.name.endsWith(".xlsx")) {
      setAlertState({
        open: true,
        title: "Formato de archivo inválido",
        message: "Solo se aceptan archivos .xlsx. Por favor, exportá el archivo desde Campaign Manager.",
        severity: "error",
      });
      return;
    }

    try {
      const { changes, errors } = await parseImportedCampaigns(file);

      if (errors.length > 0) {
        const detail = errors
          .map((e) => `• ${e.campaignName} — ${e.field}: "${e.value}"`)
          .join("\n");
        setAlertState({
          open: true,
          title: "Valores no numéricos detectados",
          message: `Las siguientes celdas tienen valores inválidos. Corregílos y volvé a importar:\n${detail}`,
          severity: "error",
        });
        return;
      }

      onImport(changes);
    } catch {
      setAlertState({
        open: true,
        title: "Error al procesar el archivo",
        message: "No se pudo leer el archivo. Asegurate de que sea un xlsx exportado desde Campaign Manager.",
        severity: "error",
      });
    }
  };

  const handleFileChange = (e) => {
    processFile(e.target.files?.[0]);
    e.target.value = "";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragActive(false);
    processFile(e.dataTransfer.files?.[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragActive(true);
  };

  const handleDragLeave = () => setIsDragActive(false);

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      style={{
        border: `2px dashed ${isDragActive ? "#354887" : "#ccc"}`,
        padding: "20px",
        margin: "20px",
        height: "75%",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        backgroundColor: isDragActive ? "#f0f4ff" : "transparent",
        transition: "all 0.2s",
      }}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".xlsx"
        style={{ display: "none" }}
        onChange={handleFileChange}
        disabled={loading}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          gap: 8,
        }}
      >
        {isDragActive ? (
          <>
            <CloudDownloadIcon sx={{ color: "#354887", fontSize: 40 }} />
            <Typography>Suelta el archivo aquí...</Typography>
          </>
        ) : (
          <>
            <CloudUploadIcon sx={{ fontSize: 40, color: "#999" }} />
            <Typography>
              Arrastra un archivo aquí, o haz clic para seleccionar
            </Typography>
            <Button
              variant="contained"
              disabled={loading}
              onClick={() => inputRef.current?.click()}
              sx={{ backgroundColor: "#354887", "&:hover": { backgroundColor: "#354887" } }}
            >
              Subir archivo
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
